/**
 * @module app.bdc.reports.navReportCtrl
 *
 */

define(['angular'], function(angular) {

    function NavReportCtrl(
        $rootScope,
        $scope,
        $sce,
        reportRoutingService,
        electronicSignatureService,
        commonService,
        pricesService,
        tillPackService,
        orderService,
        csvService,
        $log,
        Notification,
        userService,
        editionService,
        $uibModal,
        $window
    ) {
        var self = {};

        self.order = $rootScope.order;
        self.orderForm = $rootScope.orderForm;
        self.user = $rootScope.user;
        self.reportRouting = reportRoutingService;
        self.loading = false;
        self.exporting = false;
        self.isExt = userService.isExternalUser($rootScope.user);
        self.displayInvoice = false;
        self.title = self.order && self.order.idElectronicSignature ? 'Signature électronique' : 'Impression';

        self.sign = function() {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'sendElectronicSignature.html',
                controller: 'SendElectronicSignatureCtrl',
                controllerAs: 'sendElectronicSignatureCtrl',
                size: 'lg',
                resolve: {}
            });
            modal.result.then(function(res) {
                self.loading = true;
                electronicSignatureService
                    .signAnOrder(self.order, res.vad, res.joinRac, res.documents, self.orderForm, self.user, res.liz)
                    .then(function(resp) {
                        self.order.dateSendElectronicSignature = resp.dateSendElectronicSignature;
                        self.order.idElectronicSignature = resp.idElectronicSignature;
                        Notification.success("Le bon de commande a été envoyé vers l'API");
                        self.loading = false;
                        if(!res.vad)
                            self.reportRouting.goToESign(self.order);
                    })
                    .catch(function(err) {
                        $log.error(err);
                        Notification.error(err.data);
                        self.loading = false;
                    })
                    .finally(()=>{
                        self.loading = false;
                    });
            });
        };

        self.cgv = function() {
            var modal = $uibModal.open({
                animation: true,
                templateUrl: 'sendPdfToMergeCgv.html',
                controller: 'SendPdfToMergeCgvCtrl',
                controllerAs: 'sendPdfToMergeCgvCtrl',
                size: 'lg',
                resolve: {}
            });

            modal.result.then(function(res) {
                console.log(res.documents.bundle)
                self.loading = true;
                editionService
                    .mergeDocumentWithCgv(res.documents.bundle.split(',')[1])
                    .then(function(data) {
                        _printPreview(data.base64);
                    })
                    .catch(function(err) {
                        $log.error(err);
                        Notification.error('Une erreur est survenue à l\'affichage du PDF.');
                    })
                    .finally(()=>{
                        self.loading = false;
                    });
            });
        };

        // let _printPreview = (data, type = 'application/pdf') => {
        //     let blob = null;
        //     blob = commonService.b64toBlob(data, type);
        //     const blobURL = URL.createObjectURL(blob);
        //     // $window.open(blobURL);
        //     // const theWindow = $window.open(blobURL);
        //     const theDoc = $window.document;
        //     const theScript = document.createElement('script');
        //     function injectThis() {
        //         window.print();
        //     }
        //     theScript.innerHTML = `window.onload = ${injectThis.toString()};`;
        //     theDoc.body.appendChild(theScript);
        // };

        let _printPreview = (data, type = 'application/pdf') => {
            try {
                if (!data) {
                    throw new Error('Données invalides');
                }

                // Supprime l'ancien embed s'il existe
                let oldIframe = $window.document.querySelector('#pdfViewer');
                if (oldIframe) {
                    oldIframe.remove();
                }

                const blob = commonService.b64toBlob(data, type);
                const blobURL = URL.createObjectURL(blob);

                // Création de l'élément embed
                const iframeElement = $window.document.createElement('iframe');
                iframeElement.id = 'pdfViewer';
                iframeElement.src = blobURL;
                iframeElement.type = type;
                iframeElement.style.width = '800px';
                iframeElement.style.height = '600px';

                // Ajout de l'élément au document
                $window.document.body.appendChild(iframeElement);
                iframeElement.style.display = 'none';
                // Attendre que le PDF soit chargé avant d'imprimer
                iframeElement.onload = () => {
                    // Nettoyage de l'URL
                    URL.revokeObjectURL(blobURL);

                    // Impression automatique
                    setTimeout(function() {
                        // iframeElement.focus();
                        iframeElement.contentWindow.print();
                    }, 1);
                };
                // on laisse 10s pour cliquer sur le bouton imprimer après on supprime l'iframe
                setTimeout(function() {
                    iframeElement.remove();
                }, 30000);
            } catch (error) {
                console.error('Erreur lors de la prévisualisation:', error);
                throw error;
            }
        };

        /* =========================================================================================== */
        /*                                            CSV                                              */
        /* =========================================================================================== */

        self.exportPnl = () => {
            self.exporting = true;
            let tabObj = []; // label,quantité,mensualité,nb_mois/achat,code_x3
            let nbMonth =   self.order.contract.contractType.code === 'LOC24'
                ? 24
                : self.order.contract.contractType.code === 'LOC36'
                    ? 36
                    : self.order.contract.contractType.code === 'LOC48'
                        ? 48
                        : self.order.contract.contractType.code === 'LOC60'
                            ? 60
                            : 1;
            let tills = tillPackService.getTillsByTillCode($rootScope.orderForm, self.order);
            let degressiveRate = pricesService.getDegressiveRate(self.order, orderService.getNbTills(self.order.tills), true);
            let prices = pricesService.getDegressiveRateTillPrices(self.order.contract.contractType.code, degressiveRate);
            let mixedTillPrices = pricesService.getMixedTillPrice(
                tillPackService.getMixedPack(tills),
                self.order.contract.contractType.code
            );
            self.tills = tillPackService.getPricesByTillPack(self.order, prices, mixedTillPrices, tills);

            for (let till of self.order.tills){
                let obj = {
                    label: till.label,
                    quantite : till.nbTills,
                    mensualite: self.tills[till.tillType.code].price,
                    duree: nbMonth,
                    codeX3: till.identifiersX3[0]
                }
                tabObj.push(obj);
            }
            for (let promo of self.order.promotions){
                let obj = {
                    label: promo.label,
                    quantite : 1,
                    mensualite: -self.order.prices.promotions[promo.code],
                    duree: nbMonth,
                    codeX3: ''
                }
                tabObj.push(obj);
            }
            let softwares = self.order.options.reduce((curr, opt) => {
                if(['LOGICIEL_CAISSE', 'SERVICE_LOGICIEL'].indexOf(opt.optionType.code) !== -1)
                    curr.push(opt);
                return curr;
            },[]);
            for(let soft of softwares) {
                let obj = {
                    label: soft.description,
                    quantite: soft.nbOptions,
                    mensualite: pricesService.getOptionUnitPrice(soft) * soft.nbOptions,
                    duree: nbMonth,
                    codeX3: soft.identifiersX3 && soft.identifiersX3.length > 0 ? soft.identifiersX3[0] : ""
                };
                tabObj.push(obj);
            }
            let prestations = self.order.options.reduce((curr, opt) => {
                if(['PRESTATION'].indexOf(opt.optionType.code) !== -1)
                    curr.push(opt);
                return curr;
            },[]);
            for(let opt of prestations) {
                let obj = {
                    label: opt.label,
                    quantite: opt.nbOptions,
                    mensualite: pricesService.getOptionUnitPrice(opt) * opt.nbOptions,
                    duree: opt.contractType.label === 'Achat' ? 1 : nbMonth,
                    codeX3: opt.identifiersX3[0]
                };
                tabObj.push(obj);
            }
            for (let cashDrawer of self.order.cashDrawers){
                let obj = {
                    label: cashDrawer.label,
                    quantite : cashDrawer.nbCashDrawers,
                    mensualite: pricesService.getCashDrawerUnitPrice(cashDrawer) * cashDrawer.nbCashDrawers,
                    duree: nbMonth,
                    codeX3: cashDrawer.identifiersX3[0]
                }
                tabObj.push(obj);
            }

            let options = self.order.options.reduce((curr, opt)=> {
                if(['SCANUP', 'DEFAUT', 'ACCESSOIRE_CAISSE', 'IMPRIMANTE', 'EXTENSION', 'TIROIR_CAISSE','TPE'].indexOf(opt.optionType.code) !== -1)
                    curr.push(opt);
                return curr;
            },[]);
            for(let opt of options) {
                let obj = {
                    label: opt.label,
                    quantite: opt.nbOptions,
                    mensualite: pricesService.getOptionUnitPrice(opt) * opt.nbOptions,
                    duree: opt.contractType.label === 'Achat' ? 1 : nbMonth,
                    codeX3: opt.identifiersX3 && opt.identifiersX3.length > 0 ? opt.identifiersX3[0] : ""
                };
                tabObj.push(obj);
            }
            if (self.order.prices.reintegration > 0){
                let obj = {
                    label: 'Réintégration',
                    quantite: 1,
                    mensualite: self.order.prices.reintegration.toFixed(2) ,
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }
            // if (self.order.contract.monthlyPaymentFidelity > 0){
            //     let obj = {
            //         label: 'Fidelité',
            //         quantite: "",
            //         mensualite: self.order.contract.monthlyPaymentFidelity,
            //         duree: self.order.contract.nbMonthsFidelity,
            //         codeX3: ""
            //     };
            //     tabObj.push(obj);
            // }
            // if (self.order.contract.monthlyPaymentCalage > 0){
            //     let obj = {
            //         label: 'Calage',
            //         quantite: "",
            //         mensualite: self.order.contract.monthlyPaymentCalage,
            //         duree: self.order.contract.nbMonthsCalage,
            //         codeX3: ""
            //     };
            //     tabObj.push(obj);
            // }
            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.exceptionalOffer > 0){
                let obj = {
                    label: 'Offre du mois',
                    quantite: 1,
                    mensualite: -self.order.goodwillGestures.amount.exceptionalOffer.toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.fullPremiumOffer > 0){
                let obj = {
                    label: 'Offre Pack full premium',
                    quantite: 1,
                    mensualite: -self.order.goodwillGestures.amount.fullPremiumOffer.toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            let tillMaintenance = self.order.options.reduce((curr, opt)=> {
                if(['MAINTENANCE'].indexOf(opt.optionType.code) !== -1)
                    curr.push(opt);
                return curr;
            },[]);
            for(let opt of tillMaintenance) {
                let obj = {
                    label: opt.label,
                    quantite: opt.nbOptions,
                    mensualite: self.order.prices.maintenanceTill,
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            let gestions = self.order.options.reduce((curr, opt)=> {
                if(['GESTION_SCANUP', 'GESTION'].indexOf(opt.optionType.code) !== -1)
                    curr.push(opt);
                return curr;
            },[]);
            for(let opt of gestions) {
                let obj = {
                    label: opt.label,
                    quantite: opt.nbOptions,
                    mensualite: pricesService.getOptionUnitPrice(opt) * opt.nbOptions,
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.launchBimediaPay > 0){
                let obj = {
                    label: 'Offre lancement Bimedia Pay',
                    quantite: 1,
                    mensualite: -self.order.prices.scanupBimediaPayDiscount.toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.prices.activateBBoosterOptions > 0){
                let obj = {
                    label: 'B Booster - frais de lise en service',
                    quantite: 1,
                    mensualite: self.order.prices.activateBBoosterOptions.toFixed(2),
                    duree: 1,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.prices.BBoosterOptions > 0){
                let obj = {
                    label: 'Pack B Booster',
                    quantite: 1,
                    mensualite: self.order.prices.BBoosterOptions.toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.moneyTransferServices > 0){
                let obj = {
                    label: 'Services de Transfert d\'argent',
                    quantite: 1,
                    mensualite: -self.order.goodwillGestures.amount.moneyTransferServices.toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
           }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupServices > 0){
                let obj = {
                    label: 'Offre Services sur Scan\'Up',
                    quantite: 1,
                    mensualite: -(self.order.goodwillGestures.amount.scanupServices / 12).toFixed(2),
                    duree: 12,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.eagle > 0){
                let obj = {
                    label: 'Offre Eagle',
                    quantite: 1,
                    mensualite: -(self.order.goodwillGestures.amount.eagle / nbMonth).toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.revenue > 0){
                let obj = {
                    label: 'Accélérateur de revenu',
                    quantite: 1,
                    mensualite: -(self.order.goodwillGestures.amount.revenue / nbMonth).toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.scanupPartExchange > 0){
                let obj = {
                    label: 'Offre de reprise Scan\'Up',
                    quantite: 1,
                    mensualite: -(self.order.goodwillGestures.amount.scanupPartExchange).toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }
            if(self.order.goodwillGestures && self.order.goodwillGestures.amount.tillPartExchange > 0){
                let obj = {
                    label: 'Offre de reprise Caisse',
                    quantite: 1,
                    mensualite: -(self.order.goodwillGestures.amount.tillPartExchange).toFixed(2),
                    duree: nbMonth,
                    codeX3: ""
                };
                tabObj.push(obj);
            }

            csvService.JSONtoCSVConvertor(tabObj, `P&L ${self.order.client.firstName} ${self.order.client.lastName}`, true);
            self.exporting = false;
        }

        return self;
    }

    NavReportCtrl.$inject = [
        '$rootScope',
        '$scope',
        '$sce',
        'reportRoutingService',
        'electronicSignatureService',
        'commonService',
        'pricesService',
        'tillPackService',
        'orderService',
        'csvService',
        '$log',
        'Notification',
        'userService',
        'editionService',
        '$uibModal',
        '$window'
    ];

    angular.module('app.bdc.reports.navReportCtrl', []).controller('NavReportCtrl', NavReportCtrl);
});
